//@flow
import React from 'react';
import { Icon } from '@finect/tabular-components/Icon';
import { getArticleRel, getArticleImageUrl } from '@finect/tabular-components/Articles';
import { normalizeVideo } from '@finect/tabular-components/Videos';

import { getArticlePath, pickArticleAuthor } from '../../../utils/articles';
import { Author } from '../partials';

export const getCommonProps = (
  article: Object,
  userSubscriptions: Object,
  plus?: boolean,
  imageHD?: boolean
): Object => {
  const { title } = article;

  const date = article.revision.updated;
  const externalUrl = article.body.url ? article.body.url : '';
  const externalPath = externalUrl && externalUrl.match('^(?:https?://)?(?:[^@\n]+@)?(?:www.)?([^:/\n?]+)');

  const link = getArticlePath(article);

  const displayAuthor = pickArticleAuthor(article);

  const image = article.image
    ? getArticleImageUrl(article, false, plus ? imageHD ? 1332 : 720 : 300)
    : article.author?.subtype === 'company'
      ? `/image/${article.author.icon}`
      : null;

  const hasProfile =
    displayAuthor &&
    ((displayAuthor.subtype === 'user' && displayAuthor.features && displayAuthor.features.includes('profile')) ||
      (displayAuthor.subtype === 'company' && displayAuthor.features && displayAuthor.features.blog));

  const author = {
    type: displayAuthor?.subtype === 'company' ? 'company' : 'user',
    displayName: displayAuthor?.displayName,
    icon: displayAuthor?.icon,
    url: displayAuthor?.web
  };

  const [organization]: Array<Object> = displayAuthor?.organizations || [];

  const AuthorComponent = hasProfile ? 'a' : 'span';
  const authorProps = hasProfile
    ? { href: author.url, title: `Ver perfil de ${author.displayName}` }
    : { title: `Ver perfil de ${author.displayName}` };

  const authorContent = (
    <Author>
      <AuthorComponent {...authorProps}>
        <Icon withBorder size={1} alt={author.displayName} image={`/image/${author.icon}`} margin="0 8px 0 0" />
        <div>
          {author.displayName}
          {organization && <span className="author">{organization.displayName}</span>}
        </div>
      </AuthorComponent>
    </Author>
  );

  const tags = article.socialStats.tags.map(tag => ({
    ...tag,
    followed: Boolean(userSubscriptions?.tags && userSubscriptions?.tags.find(t => t === tag.id))
  }));

  const linkProps = externalUrl ? { rel: getArticleRel(article), target: '_blank' } : { rel: getArticleRel(article) };

  const video = normalizeVideo(externalUrl);

  return {
    title,
    date,
    externalUrl,
    externalPath,
    link,
    image,
    author,
    authorContent,
    tags,
    linkProps,
    video
  };
};
